/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import devicenames from '../../config/ios-device-identifiers.json'

const IpadTypeField = (props: any) => {
    const { datas, index } = props;
    const [info, setInfo] = useState<string>("");

    useEffect(() => {
        // @ts-ignore
        $('[data-toggle="popover"]').popover()
    }, [])

    const show = (flag: boolean) => {
        if (flag) {
            // @ts-ignore
            $(`#devicetype-${index}`).popover('show')
        } else {
            // @ts-ignore
            $(`#devicetype-${index}`).popover('hide')
        }
    }

    useEffect(() => {
        for (let dataKey in devicenames) {
            if (datas === dataKey) {
                // @ts-ignore
                setInfo(devicenames[dataKey])
            }
        }
    }, [datas])

    return (
        <td style={{ padding: '0px 10px' }}>
            <div
                id={`devicetype-${index}`}
                className={`btn btn-sm active-primary`}
                data-toggle="popover" title="Details" data-html="false" data-content={info}
                onMouseLeave={() => show(false)}
                onMouseOver={() => show(true)}
            >
                <p className='m-0'>{datas}</p>
            </div>
        </td>
    )
}

export default IpadTypeField;